import { useEffect } from "react";
import { clientCentralApiStrawberry, clientNeoBanks } from "@neonumy/api-clients";
import { onErrorGraphql } from "utils/onErrorGraphql";
import { useLazyQuery } from "@apollo/client";
import {
  GET_COMPANY_WITH_ADDRESS,
  LIST_COMPANY_MAIN_BANK_ACCOUNT,
} from "queries/centralApi/template";

export default function useTemplateApi() {
  const [
    getCompanyWithAddress,
    { data: getCompanyWithAddressData, error: getCompanyWithAddressError },
  ] = useLazyQuery<GetCompanyWithAddressOutput, GetCompanyWithAddressInput>(
    GET_COMPANY_WITH_ADDRESS,
    {
      client: clientCentralApiStrawberry,
    },
  );

  useEffect(() => {
    if (getCompanyWithAddressError) onErrorGraphql(getCompanyWithAddressError);
  }, [getCompanyWithAddressError]);

  const companyData = {
    company: getCompanyWithAddressData?.getCompany ?? null,
    address: getCompanyWithAddressData?.listAddresses?.results[0] ?? null,
  };

  const [
    getCompanyBankAccount,
    { data: getCompanyBankAccountData, error: getCompanyBankAccountError },
  ] = useLazyQuery<
    ListCompaniesBankAccountsPaginatedOutput,
    ListCompaniesBankAccountsPaginatedInput
  >(LIST_COMPANY_MAIN_BANK_ACCOUNT, {
    client: clientNeoBanks,
  });

  useEffect(() => {
    if (getCompanyBankAccountError) onErrorGraphql(getCompanyBankAccountError);
  }, [getCompanyBankAccountError]);

  const companyBankAccount =
    getCompanyBankAccountData?.listCompaniesBankAccountsPaginated?.results[0] ?? null;

  return {
    getCompanyWithAddress,
    getCompanyBankAccount,
    companyData,
    companyBankAccount,
  };
}
